import { NavigationBar } from './NavigationBar.jsx';

export const PageLayout = (props) => {
    return (
        <>
            <NavigationBar />
            <br />
            <h5 className="page-heading campus-heading">
                <center>ACADEMY CAMPUS PORTAL</center>
            </h5>
            <br />
            {props.children}
            <br />
            <footer>
                <center>
                    Acabooster Inc. 2025
                </center>
            </footer>
        </>
    );
}